import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { IReportFilter } from '../../utils/interfaces/report-filter';
import { ISummaryReport } from '../../utils/interfaces/summary-report';
import { PrintDocument } from '../print-document';
import { SummaryReportBodyComponent } from '../report-bodies/summary-report-body.component';

@Component({
  selector: 'app-print-summary',
  standalone: true,
  imports: [CommonModule, SummaryReportBodyComponent],
  template: `
    <app-summary-report-body
      [data]="data"
      [filter]="filter"
      [print]="print"
    />
  `,
})
export class PrintSummaryComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  print = true;
  orientation = 'portrait';
  data!: ISummaryReport;
  filter!: IReportFilter;

  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    const { data, filter } = this.activatedRoute.snapshot.data['data'];

    this.data = data;
    this.filter = filter;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório de resumo',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
